<template>
  <pdl-collapse
    v-if="filteredPaintSchemes.length"
    id="paint-scheme-options-list"
    :default-active="false"
    :accordion="true"
    :is-sticky="true"
    qaid="paint-scheme-options-list"
  >
    <paint-scheme-option
      v-for="option in filteredPaintSchemes"
      :key="option.id"
      :option="option"
      :qaid="getOptionQaid(option)"
    />
  </pdl-collapse>
</template>

<script>
import {mapState} from 'vuex';
import {PdlCollapse} from '@pedal/pdl-collapse';
import PaintSchemeOption from '@/components/containers/buy-zone/customization/PaintSchemeOption.vue';
import {GROUP_IDS} from '@/familyDetailsPage/store/bike-customization';

export default {
  name: 'PaintSchemeOptionsList',
  components: {
    PdlCollapse,
    PaintSchemeOption,
  },
  computed: {
    ...mapState('bikeCustomization', ['paintSchemeOptions']),

    filteredPaintSchemes() {
      return this.paintSchemeOptions?.filter((scheme) => scheme.id !== GROUP_IDS.THEME) || [];
    },
  },
  methods: {
    getOptionQaid(option) {
      return option?.description ? `paint-scheme-option-${option.description.replace(/\s+/g, '-').toLowerCase()}` : '';
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.pdl-collapse-item__header) {
  border-bottom: none;
}
</style>
